(() => {
  if (customElements.get('subscription-upsells')) {
    return;
  }

  class SubscriptionUpsells extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        upsellGroup: '[data-upsell-group]',
        detailsEl: '[data-details]',
        product: '[data-product]',
        button: '[data-button]',
        selectedText: '[data-selected-text]',
      };
      this.actionClasses = {
        added: 'is-added',
        active: 'is-active',
        limitReach: 'has-reached-limit',
      };
      this.addedProducts = [];
    }

    connectedCallback() {
      this.upsellsGroups = this.querySelectorAll(this.selectors.upsellGroup);
      if (!this.upsellsGroups.length) return;

      this.products = this.querySelectorAll(this.selectors.product);
      this.buttons = this.querySelectorAll(this.selectors.button);

      this.buttons.forEach((button) => {
        button.addEventListener('click', this.handleProductToggle.bind(this));
      });
    }

    showUpsells(sellingPlanId, variantId) {
      const selectedGroup = [...this.upsellsGroups].filter((group) => {
        const groupSellingPlanId = group.getAttribute('data-selling-plan-id');
        const groupVariantId = group.getAttribute('data-variant-id');

        if (
          sellingPlanId === groupSellingPlanId &&
          variantId === groupVariantId
        ) {
          return group;
        }
      })[0];

      this.resetUpsells();

      if (!selectedGroup) {
        return;
      }

      selectedGroup.classList.add(this.actionClasses.active);
      selectedGroup?.querySelector(this.selectors.detailsEl)?.querySelector('summary')?.click();
    }

    handleProductToggle(event) {
      const button =
        event.target.closest(this.selectors.button) || event.target;
      const group = button.closest(this.selectors.upsellGroup);
      const product = button.closest(this.selectors.product);
      const limit = parseInt(group.getAttribute('data-limit'), 10) || Infinity;

      if (!group || !product) return;

      const variantId = product.getAttribute('data-variant-id');
      const isAlreadyAdded = product.classList.contains(
        this.actionClasses.added
      );

      if (isAlreadyAdded) {
        product.classList.remove(this.actionClasses.added);
        this.addedProducts = this.addedProducts.filter(
          (p) => p.id !== variantId
        );
      } else {
        if (this.addedProducts.length >= limit) {
          group.classList.add(this.actionClasses.limitReach);
          return;
        }
        product.classList.add(this.actionClasses.added);
        this.addedProducts.push({ id: variantId });
      }

      group.querySelector(
        this.selectors.selectedText
      ).textContent = `${this.addedProducts.length}`;
      group.classList.toggle(
        this.actionClasses.limitReach,
        this.addedProducts.length >= limit
      );
    }

    resetUpsells() {
      this.upsellsGroups.forEach((group) => {
        group.classList.remove(this.actionClasses.active);
        group.classList.remove(this.actionClasses.limitReach);
        group.querySelector(this.selectors.detailsEl).open = false;
        group.querySelector(
          this.selectors.selectedText
        ).textContent = `${this.addedProducts.length}`;
      });
      this.products?.forEach((product) =>
        product.classList.remove(this.actionClasses.added)
      );
      this.addedProducts = [];
    }
  }

  customElements.define('subscription-upsells', SubscriptionUpsells);
})();
